import { render, staticRenderFns } from "./addTeachBuild.vue?vue&type=template&id=a2939392&"
import script from "./addTeachBuild.vue?vue&type=script&lang=js&"
export * from "./addTeachBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports